var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home "},[_c('div',{staticClass:"bgImg"}),_c('div',{staticClass:"position-absolute font-style text-light"},[_vm._v("SUIT")])])}]

export { render, staticRenderFns }